var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DadosRequerente } from '../common/DadosRequerente';
import React from 'react';
export var PrimeiraAbaRequerimento = function (_a) {
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, tipoRequerimento = _a.tipoRequerimento, requerimento = _a.requerimento, onValidate = _a.onValidate, invertido = _a.invertido, onChange = _a.onChange;
    return (_jsx(_Fragment, { children: _jsx(DadosRequerente, { requerimentoFieldErrorChange: function (erros) { return requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, erros)); }, onChange: function (_requerimento) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, _requerimento)); }, onValidate: function (calback) { return onValidate === null || onValidate === void 0 ? void 0 : onValidate(calback); }, requerimentoFieldError: requerimentoFieldError, tipoRequerimento: tipoRequerimento, requerimento: requerimento }) }));
};
